module.exports = __webpack_public_path__ + "static/img/plantform.12c4f24.png";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/plantform.png
// module id = 9yJ/
// module chunks = 0